<template>
  <div class="course-admin-wrapper">
    <v-btn x-large icon style="position: fixed; top: 10px; left: 10px; z-index: 5" @click="$router.push('/kurse')">
      <v-icon color="white">mdi-chevron-left</v-icon>
    </v-btn>
    <v-row class="action-cards-row">
      <v-col cols="12" md="6">
        <v-card class="action-card fill-height" outlined>
          <v-list-item three-line>
            <v-list-item-content>
              <div class="overline mb-4">Einstellungen</div>
              <v-list-item-title class="text-h6 mb-2"> Formate & Räume </v-list-item-title>
              <v-list-item-subtitle> Verwalte hier Kursformate, Räume, Labels und sieh dir die Kundenbewertungen an. </v-list-item-subtitle>
            </v-list-item-content>
            <v-list-item-avatar tile size="60">
              <v-icon color="primary" large>mdi-tune</v-icon>
            </v-list-item-avatar>
          </v-list-item>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn text color="primary" @click="$router.push('/dashboard')"> Zu den Einstellungen </v-btn>
          </v-card-actions>
        </v-card>
      </v-col>

      <v-col cols="12" md="6">
        <v-card class="action-card fill-height" outlined>
          <v-list-item three-line>
            <v-list-item-content>
              <div class="overline mb-4">Werkzeuge</div>
              <v-list-item-title class="text-h6 mb-2"> Listen & Anpassungen </v-list-item-title>
              <v-list-item-subtitle> Lade die Instruktorenliste herunter oder passe die Teilnehmerzahl für ein Kursformat an. </v-list-item-subtitle>
            </v-list-item-content>
            <v-list-item-avatar tile size="60">
              <v-icon color="primary" large>mdi-toolbox-outline</v-icon>
            </v-list-item-avatar>
          </v-list-item>
          <v-card-actions class="d-flex flex-column">
            <v-btn text color="primary" @click="downloadInstructorList">Instruktorenliste</v-btn>

            <v-btn text color="primary" @click="showParticipantDialog = true">Teilnehmer anpassen</v-btn>
          </v-card-actions>
        </v-card>
      </v-col>
    </v-row>

    <div class="list-section">
      <v-tabs v-model="tab" background-color="transparent" color="primary" grow>
        <v-tab v-for="item in items" :key="item">{{ item }}</v-tab>
      </v-tabs>
      <v-row no-gutters>
        <v-col class="my-2" align="center">
          <v-btn fab dark color="primary" @click="$router.push({ name: 'courseCreateTimeline' })">
            <v-icon>mdi-plus</v-icon>
          </v-btn>
        </v-col>
      </v-row>
      <v-divider></v-divider>

      <v-tabs-items v-model="tab">
        <v-tab-item>
          <v-row align="center" class="list-controls">
            <v-col cols="12" md="4">
              <v-select
                @change="fetchCourseList"
                v-model="selectedDay"
                :items="days"
                item-text="text"
                item-value="value"
                label="Wochentag"
                outlined
                dense
                hide-details></v-select>
            </v-col>
          </v-row>
          <div v-for="(course, y) in courseEditList" :key="course._id">
            <div v-if="showDivider(y)" class="time-divider">
              <span class="time-chip">ab {{ course.hours }}:00 Uhr</span>
            </div>
            <v-card @click="pushToCourse(course)" class="course-card my-3" outlined>
              <div class="course-card-marker"></div>
              <v-list-item three-line>
                <v-list-item-avatar size="60" class="course-avatar">
                  <lottie-player v-if="course.icon" mode="normal" :src="'/api/gf/icons/' + course.icon" :key="course.icon" />
                  <lottie-player v-else mode="normal" src="/img/lottiefiles/gf/dumbell.json" />
                </v-list-item-avatar>
                <v-list-item-content>
                  <v-list-item-title class="text-h6 mb-1">{{ course.course.name }}</v-list-item-title>
                  <v-list-item-subtitle>{{ course.instructors.map((i) => i.vorname).join(", ") }}</v-list-item-subtitle>
                  <v-list-item-subtitle>{{ courseStartDate(course) }} - {{ courseEndDate(course) }} Uhr</v-list-item-subtitle>
                </v-list-item-content>
                <v-list-item-action>
                  <div class="text-center">
                    <div class="font-weight-bold">{{ course.amount }}</div>
                    <div class="caption">Plätze</div>
                  </div>
                </v-list-item-action>
              </v-list-item>
              <v-chip v-if="course.label" small :color="course.label.color" :dark="true" class="status-chip">{{ course.label.text }}</v-chip>
            </v-card>
          </div>
        </v-tab-item>

        <v-tab-item>
          <div v-for="course in plannedCourseEditList" :key="course._id" class="mt-5">
            <v-card @click="pushToCourse(course)" class="course-card" outlined>
              <div class="course-card-marker planned"></div>
              <v-list-item three-line>
                <v-list-item-avatar size="60" class="course-avatar">
                  <lottie-player v-if="course.icon" mode="normal" :src="'/api/gf/icons/' + course.icon" :key="course.icon" />
                  <lottie-player v-else mode="normal" src="/img/lottiefiles/gf/dumbell.json" />
                </v-list-item-avatar>
                <v-list-item-content>
                  <div class="overline primary--text">{{ getDate(course.visibleAfter) }} - {{ getDate(course.hideAfter) }}</div>
                  <v-list-item-title class="text-h6 mb-1">{{ course.course.name }}</v-list-item-title>
                  <v-list-item-subtitle>{{ course.instructors.map((i) => i.vorname).join(", ") }}</v-list-item-subtitle>
                  <v-list-item-subtitle>{{ courseStartDate(course) }} - {{ courseEndDate(course) }} Uhr</v-list-item-subtitle>
                </v-list-item-content>
              </v-list-item>
            </v-card>
          </div>
        </v-tab-item>
      </v-tabs-items>
    </div>

    <v-dialog v-model="showParticipantDialog" max-width="500px" persistent>
      <v-card>
        <v-toolbar flat color="primary" dark>
          <v-toolbar-title>Teilnehmerzahl global anpassen</v-toolbar-title>
        </v-toolbar>
        <v-card-text class="pt-6">
          <p>Wähle ein Kursformat, um die Teilnehmerzahl für alle zukünftigen Kurse dieses Formats anzupassen.</p>
          <course-search :value="selectedCourse" label="Kursformat wählen" rights="gf_c_plan" @update="updateCourse" outlined></course-search>
          <v-text-field v-model="participantAmount" type="number" label="Neue Anzahl Plätze" outlined class="mt-4"></v-text-field>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions class="pa-4">
          <v-btn
            text
            @click="
              showParticipantDialog = false
              participantAmount = null
            "
            >Abbrechen</v-btn
          >
          <v-spacer></v-spacer>
          <v-btn class="px-4" color="primary" @click="updateParticipantAmount">Speichern</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <router-view @resetTab="changeTab" @updateList="fetchCourseList"></router-view>
  </div>
</template>

<script>
import api from "../../api"
import userService from "../../services/userService"
import { mapGetters } from "vuex"
import userSearch from "../../components/userSearch.vue"
import courseSearch from "../../components/courseSearch.vue"
export default {
  name: "courseEdit",
  components: { userSearch, courseSearch },
  data() {
    return {
      selectedCourse: null,
      tab: null,
      items: ["Wiederholend", "Zeitlich begrenzt"],
      dialog: true,
      selectedDay: 1,
      days: [
        { value: 1, text: "Montag" },
        { value: 2, text: "Dienstag" },
        { value: 3, text: "Mittwoch" },
        { value: 4, text: "Donnerstag" },
        { value: 5, text: "Freitag" },
        { value: 6, text: "Samstag" },
        { value: 7, text: "Sonntag" },
      ],
      plannedCourseEditList: [],
      courseEditList: [],
      showParticipantDialog: false,
      participantAmount: null,
    }
  },
  async created() {
    this.fetchCourseList()
  },
  methods: {
    updateCourse(newCourse, oldCourse) {
      this.selectedCourse = newCourse
      console.log(newCourse)
    },
    async updateParticipantAmount() {
      if (!this.participantAmount) {
        this.$toast.error("Bitte trage einge gültige Anzahl Plätze ein")
        return
      }
      if (!(this.selectedCourse && this.selectedCourse._id)) {
        this.$toast.error("Bitte wähle ein Kursformat aus")
        return
      }

      if (confirm("Alle " + this.selectedCourse.name + " Kurse auf " + this.participantAmount + " Teilnehmerplätze anpassen?")) {
        try {
          let status = await api.updateGFParticipantAmount({ course_id: this.selectedCourse._id, amount: this.participantAmount })

          if (status?.status?.nModified) this.$toast.success("Es wurden " + status.status.nModified + " Kursplanungen angepasst")
          this.fetchCourseList()
          this.participantAmount = null
          this.showParticipantDialog = false
        } catch (e) {
          this.$toast.error("Es gab einen Fehler beim Speichern")
        }
      } else {
        this.$toast.error("Abgebrochen")
      }
    },
    async downloadInstructorList() {
      let status = await api.getGFInstructorListExcel()

      if (window.flutter_inappwebview) {
        console.log("FLUTTER IOS DOWNLOAD PDF START")
        var reader = new FileReader()
        reader.readAsDataURL(status)
        let ref = this
        reader.onloadend = function () {
          var dataUrl = reader.result
          var base64 = dataUrl.split(",")[1]
          console.log(base64)
          window.flutter_inappwebview.callHandler(
            "blobToBase64Handler",
            base64.toString(),
            "xlsx",
            "Instruktorenliste_" + ref.$moment().format("YYYY-MM-DD")
          )
        }
      } else {
        saveAs(status, "Instruktorenliste_" + this.$moment().format("YYYY-MM-DD"))
      }
    },
    changeTab(index) {
      this.tab = index
    },
    getDate(ts) {
      return this.$moment(ts * 1000).format("DD.MM.YY")
    },

    pushToCourse(course) {
      this.$router.push({ name: "courseEditTimeline", params: { id: course._id } })
    },
    courseEndDate(course) {
      let endTime = this.$moment()
      endTime.set({
        hours: course.hours,
        minutes: course.minutes,
        seconds: 0,
        miliseconds: 0,
      })

      endTime.add("minutes", course.duration)
      return endTime.format("LT")
    },
    courseStartDate(course) {
      let startTime = this.$moment()

      startTime.set({
        hours: course.hours,
        minutes: course.minutes,
        seconds: 0,
        miliseconds: 0,
      })

      return startTime.format("LT")
    },
    async fetchCourseList() {
      let courseList = await api.fetchCourseListEdit(this.selectedDay)
      this.courseEditList = courseList.repeating
      this.plannedCourseEditList = courseList.planned
    },
    showDivider(y) {
      if (y - 1 >= 0) {
        if (this.courseEditList[y].hours !== this.courseEditList[y - 1].hours) {
          return true
        } else {
          return false
        }
      } else {
        return true
      }
    },
  },
  watch: {},
  computed: {},
}
</script>
<style lang="scss" scoped>
.course-admin-wrapper {
  max-width: 800px;
  margin: auto;
  padding: 24px 16px 120px 16px;
}

// 1. Header-Sektion
.admin-header {
  margin-bottom: 32px;
  padding: 0 8px;
}

// 2. Action Cards
.action-cards-row {
  margin-bottom: 32px;
}
.action-card {
  border-radius: 16px;
  transition: all 0.2s ease-in-out;
  border: 1px solid #e0e0e0;

  &:hover {
    transform: translateY(-4px);
    box-shadow: 0 8px 20px rgba(0, 0, 0, 0.08) !important;
  }
}

// 3. Kurslisten-Sektion
.list-section {
  margin-top: 16px;
}
.list-controls {
  padding: 16px 8px 8px 8px;
}

// Zeit-Trenner (identisch zur Kursliste)
.time-divider {
  padding: 24px 16px 8px;
  .time-chip {
    background-color: #e9ebf0;
    color: #5a6470;
    font-weight: 600;
    font-size: 0.8rem;
    padding: 6px 14px;
    border-radius: 20px;
  }
}

// Modernisierte Kurs-Karte (adaptiert von der Kursliste)
.course-card {
  width: 100%;
  background: #ffffff !important;
  border-radius: 24px !important;
  border: 1px solid #ededf0;
  box-shadow: 0 4px 12px rgba(0, 20, 50, 0.05);
  transition: transform 0.2s ease-out, box-shadow 0.2s ease-out;
  cursor: pointer;
  position: relative; // Wichtig für den Marker

  &:hover {
    transform: translateY(-4px);
    box-shadow: 0 6px 16px rgba(0, 20, 50, 0.08);
  }
}

.course-card-marker {
  position: absolute;
  left: 0;
  top: 25%;
  height: 50%;
  width: 6px;
  background-color: var(--v-primary-base);
  border-top-right-radius: 4px;
  border-bottom-right-radius: 4px;

  &.planned {
    background-color: #fb8c00; // Orange für geplante
  }
}

.course-avatar {
  background-color: #f7f8fa;
  border-radius: 18px;
  border: 1px solid #ededf0;
  // Lottie Player anpassen
  .lottie-player {
    width: 52px;
    height: 66px;
  }
}

.status-chip {
  position: absolute;
  top: 12px;
  right: 12px;
  z-index: 2;
  font-weight: bold;
}

// 4. Neuer FAB zum Erstellen
.add-fab {
  position: fixed;
  bottom: 80px;
  right: 24px;
  z-index: 100;
}
</style>
